import IconAttention from '@/assets/icons/ic_logic-g-app_attention.svg'

import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'

interface Props extends ModalProps {
  onOk: () => void
}

export const ConfirmResetPassword = ({
  isOpen,
  onOk,
  onRequestClose,
  ...rest
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '48px 35px',
          width: '600px',
        },
      }}
      onRequestClose={onRequestClose}
      {...rest}
    >
      <h3 className="mb-[15px] mt-[10px] text-center text-2xl font-bold tracking-widest text-primary-text">
        本当にリセットしますか?
      </h3>

      <div className="flex justify-center text-[#D7DDF3]">
        <IconAttention width={104} aria-hidden={true} />
      </div>

      <p className="mt-4 text-center text-[15px] font-medium tracking-widest text-secondary-text">
        リセットするとパスワードを元に戻せません。
        <br />
        よろしいですか？
      </p>

      <div className="mt-[50px] flex justify-center">
        <Button variant="secondary" className="w-[200px]" onClick={onOk}>
          リセットする
        </Button>
      </div>
    </Modal>
  )
}
